export const DUMMY_ACTION_SUCCESS = 'DUMMY_ACTION_SUCCESS';
export const DUMMY_ACTION_SAGA = 'DUMMY_ACTION_SAGA';
export const SET_AUTHENTICATION = 'SET_AUTHENTICATION'
export const LOGOUT = 'LOGOUT'